import { gql } from "@apollo/client";

export const deleteBlueprint = gql`
  mutation DeleteBlueprint($input: DeleteBlueprintRequest) {
    DeleteBlueprint(input: $input) {
      deleted
    }
  }
`;
